var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRookB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    stroke: "rgb(240,240,240)",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 11,14 L 11,9 L 15,9 L 15,11 L 20,11 L 20,9 L 25,9 L 25,11 L 30,11 L 30,9 L 34,9 L 34,14 L 31,17 L 31,29.5 L 33,32 L 33,36 L 12,36 L 12,32 L 14,29.5 L 14,17 Z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9,39 L 36,39 L 36,36 L 9,36 L 9,39 z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "rgb(240,240,240)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1.2,
    x1: 11,
    y1: 14,
    x2: 34,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 0.8,
    x1: 14,
    y1: 17,
    x2: 31,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 0.8,
    x1: 14,
    y1: 29.5,
    x2: 31,
    y2: 29.5
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1.2,
    x1: 12,
    y1: 32,
    x2: 33,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1.2,
    x1: 12,
    y1: 35.5,
    x2: 33,
    y2: 35.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRookB);
export default __webpack_public_path__ + "static/media/rook-b.48cd77eced6de2cf01634bb0553e535d.svg";
export { ForwardRef as ReactComponent };